import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { articlesAPI } from "../services/api";
import Spinner from "../components/Spinner";
import ScrollToTopButton from "../components/ScrollToTopButton";
import {
  getPublicLessonPath,
  getTutorialLessonPath,
  TUTORIAL_FOLDER,
} from "../constants/tutorialContent";
import "./ViewLesson.css";

const SharedLesson = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const lessonPath =
    article?.title === TUTORIAL_FOLDER
      ? getTutorialLessonPath()
      : article?._id
        ? getPublicLessonPath(article._id)
        : "/";

  useEffect(() => {
    const loadSharedArticle = async () => {
      try {
        const response = await articlesAPI.getSharedArticle(token);
        setArticle(response.data.article);
      } catch (err) {
        setError("Shared lesson not found or no longer available");
      } finally {
        setLoading(false);
      }
    };

    loadSharedArticle();
  }, [token]);

  if (loading) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        minHeight: "100vh",
        background: "var(--color-bg-primary)"
      }}>
        <Spinner visible={true} />
      </div>
    );
  }

  if (error || !article) {
    return (
      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        justifyContent: "center", 
        alignItems: "center", 
        minHeight: "100vh",
        background: "var(--color-bg-primary)",
        color: "var(--color-text-primary)",
        gap: "20px"
      }}>
        <h2>{error || "Lesson not found"}</h2>
        <button
          onClick={() => navigate("/")}
          style={{
            padding: "10px 20px",
            background: "var(--color-primary)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "14px"
          }}
        >
          Go to Home
        </button>
      </div>
    );
  }

  return (
    <div className="shared-lesson-page" style={{
      minHeight: "100vh",
      background: "var(--color-bg-primary)",
      padding: "40px 20px"
    }}>
      <div style={{
        maxWidth: "900px",
        margin: "0 auto"
      }}>
        <div style={{
          marginBottom: "20px",
          paddingBottom: "20px",
          borderBottom: "1px solid var(--color-border)"
        }}>
          <div style={{
            fontSize: "13px",
            color: "var(--color-text-secondary)",
            marginBottom: "10px"
          }}>
            Shared by {article.creatorShareCode} from{" "}
            <a 
              href={lessonPath}
              style={{ 
                color: "var(--color-primary)", 
                textDecoration: "underline",
                fontWeight: "500"
              }}
            >
              Asasiasa
            </a>
          </div>
          {article.chapter && (
            <h1 style={{
              fontSize: "2rem",
              fontWeight: "300",
              color: "var(--color-text-primary)",
              marginBottom: "0.5rem"
            }}>
              {article.chapter}
            </h1>
          )}
          {article.author && (
            <div style={{
              fontSize: "1.5rem",
              fontWeight: "300",
              color: "var(--color-text-primary)"
            }}>
              {article.author}
            </div>
          )}
        </div>
        
        <div style={{
          fontSize: "1.125rem",
          lineHeight: "1.8",
          color: "var(--color-text-primary)",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word"
        }}>
          {article.body}
        </div>

        <div style={{
          marginTop: "40px",
          paddingTop: "20px",
          borderTop: "1px solid var(--color-border)",
          textAlign: "center"
        }}>
          <button
            onClick={() => navigate("/")}
            style={{
              padding: "10px 20px",
              background: "var(--color-primary)",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px"
            }}
          >
            Explore Asasiasa
          </button>
        </div>
      </div>
      <ScrollToTopButton scrollContainerSelector=".app-app" />
    </div>
  );
};

export default SharedLesson;
